import React from "react"

import CurvedText from "./CurvedText"
import { Element } from "legacy/components/shared/base"

interface OwnProps {
  curvedText?: string | null
}

export type CurvedTextContainerProps = OwnProps

const CurvedTextContainer: React.FC<CurvedTextContainerProps> = ({
  curvedText,
}): React.ReactElement | null => {
  if (!curvedText) return null

  return (
    <Element
      alignItems="center"
      display="flex"
      fontSize="36px"
      fontWeight="800"
      justifyContent="center"
      mt={["-2%", "0", "0"]}
      overflow="hidden"
      width={["100%", "100%", "100%", "50%"]}
    >
      <CurvedText height={147} overlap={true} width={513}>
        {curvedText}
      </CurvedText>
    </Element>
  )
}

export default CurvedTextContainer
